import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { translate } from '@haldor/ui';
import { connect } from "react-redux";
import { Form, Field } from "react-final-form";
import { withRouter } from 'react-router-dom';
import { addError } from "actions";
import { getPlanDetails, updatePlan, createPlan } from "actions/plans";
import { getSection, toggleSelectedSection, clearSelectedSections } from "actions/sections";
import { saveBlocksOnReference, updateBlocksOnReference, deleteBlock, createAssessmentBlock, updateAssessmentBlock } from 'actions/blocks';
import { getRootUrl } from "helpers/url";
import BlockEditor from 'components/BlockEditor';
import BlockAssessments from 'components/BlockAssessments';
import BlockPurpose from "components/Inputs/BlockPurposeField";
import BlockCoreContentField from "components/Inputs/BlockCoreContentField";
import Select from "components/Inputs/select";
import DatePickerFromTo from "../Partials/DatePickerFromTo";
import GroupSelector from "../Partials/GroupSelector";
import TeacherAdjustments from "containers/AdditionalAdjustments/Display/TeacherAdjustments";
import { Checkbox, Button } from '@haldor/ui';
import { Expandable, Spinner } from "UI";
import api from "lib/api";
import moment from "moment";

var SinglePlanForm = /*#__PURE__*/function (_Component) {
  _inherits(SinglePlanForm, _Component);

  var _super = _createSuper(SinglePlanForm);

  function SinglePlanForm(props) {
    var _this;

    _classCallCheck(this, SinglePlanForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.cloneView) {
        _this.setState({
          loading: true
        });

        _this.props.getPlanDetails(_this.props.plan.id).then(function () {
          _this.setState({
            loading: false
          });
        });
      }

      var sectionId = null;

      if (_this.props.initialValues != null) {
        sectionId = _this.props.initialValues.sectionId;
      }

      if (_this.props.cloneView && _this.props.section != null) {
        sectionId = _this.props.section.id;
      } else if (_this.props.sectionId != null) {
        sectionId = _this.props.sectionId;
      }

      if (sectionId != null) {
        var find = _this.props.groups.find(function (t) {
          return t.id == sectionId;
        });

        if (find == null) {
          _this.setState({
            SectionId: 0
          });
        } else {
          _this.setState({
            SectionId: sectionId
          });

          _this.props.getSection(sectionId).then(function () {
            if (!_this.props.editView) {
              _this.setState({
                students: _this.props.section.students
              });
            }

            _this.props.toggleSelectedSection(_this.props.section);
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.clearSelectedSections();
    });

    _defineProperty(_assertThisInitialized(_this), "required", function (value) {
      if (typeof value !== "undefined" && value !== "") {
        if (value.length > 199) {
          // Field failed validation, return error for this field (String)
          return _this.props.translate("field-max-200-chars");
        } // Field passes validation, return a undefined error for this field
        // Rule: Not undefined and not an empty string and not over 200 characters


        return undefined;
      } // Field failed validation, return error for this field (String)


      return _this.props.translate("field-needs-input");
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      var initialValues = _this.props.initialValues;
      var _this$state = _this.state,
          dateStart = _this$state.dateStart,
          dateEnd = _this$state.dateEnd,
          SectionId = _this$state.SectionId,
          status = _this$state.status;

      if (_this.state.SectionId == 0) {
        _this.props.addError(_this.props.translate("pick-a-section"), "error");
      }

      return new Promise(function (resolvePlan) {
        values.timeStart = dateStart.set({
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0
        });
        values.timeEnd = dateEnd.set({
          hour: 23,
          minute: 59
        });
        values.sectionId = SectionId;
        values.students = _this.state.students;
        values.students = values.students.filter(function (t) {
          return t.remove != true;
        });
        var blocks = [];
        var deletedBlocks = [];
        var assessmentBlocks = [];
        var promises = [];

        if (values.assessmentBlocks != null) {
          assessmentBlocks = _toConsumableArray(values.assessmentBlocks);
        }

        if (values.blocks != null) {
          blocks = _toConsumableArray(values.blocks);
          blocks.forEach(function (block) {
            if (block.type == 'Haldor.Blocks.Assignment') {
              if (block.resources != null) {
                var resources = [];
                block.resources.forEach(function (resource) {
                  if (resource.existing) {
                    assessmentBlocks.forEach(function (block) {
                      promises.push(new Promise(function (resolve) {
                        if (resource['@odata.type'] == 'haldor.assignment.block.teamsassignment') {
                          api.get("assignments/".concat(resource.id, "/details")).then(function (response) {
                            _this.props.createAssessmentBlock(block, response.data.id, 'ASSIGNMENT').then(function () {
                              resolve(1);
                            });
                          });
                          return true;
                        }

                        _this.props.createAssessmentBlock(block, resource.id, 'ASSIGNMENT').then(function () {
                          resolve(1);
                        });
                      }));
                    });
                  }

                  resources.push({
                    id: resource.id,
                    '@odata.type': resource['@odata.type']
                  });
                });
                block.resources = resources;
              }
            }

            return block;
          });

          if (initialValues != null && initialValues.blocks != null) {
            deletedBlocks = _toConsumableArray(initialValues.blocks).filter(function (block) {
              return !blocks.find(function (_bl) {
                return _bl.id == block.id;
              }) && !values.assessmentBlocks.find(function (_bl) {
                return _bl.id == block.id;
              });
            });
          }
        }

        delete values.blocks;

        if (status != null) {
          values.status = status;
        }

        var that = _assertThisInitialized(_this);

        if (_this.props.editView && _this.props.cloneView == false) {
          // values.associatedCoreContent[0].ReferenceId = initialValues.id;
          promises.push(new Promise(function (resolve) {
            _this.props.updatePlan(values).then(function () {
              resolve(1);
            });
          }));

          if (blocks != null && blocks.length > 0) {
            var updatePromise = new Promise(function (resolve) {
              _this.props.updateBlocksOnReference(blocks, initialValues.id, 'PLAN').then(function () {
                resolve(1);
              });
            });
            promises.push(updatePromise);
          }

          if (values.assessmentBlocks != null) {
            values.assessmentBlocks.forEach(function (block) {
              promises.push(new Promise( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
                  var initialBlock;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          initialBlock = _this.props.initialValues.assessmentBlocks.find(function (b) {
                            return b.id == block.id;
                          });

                          if (!(initialBlock != null)) {
                            _context.next = 6;
                            break;
                          }

                          _context.next = 4;
                          return _this.props.updateAssessmentBlock(block, initialBlock);

                        case 4:
                          _context.next = 8;
                          break;

                        case 6:
                          _context.next = 8;
                          return _this.props.createAssessmentBlock(block, initialValues.id, 'PLAN');

                        case 8:
                          resolve(1);

                        case 9:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()));
            });
          }

          if (deletedBlocks.length > 0) {
            deletedBlocks.forEach(function (block) {
              var deletePromise = new Promise(function (resolve) {
                _this.props.deleteBlock(block.id).then(function () {
                  resolve(1);
                });
              });
              promises.push(deletePromise);
            });
          }

          Promise.all(promises).then(function () {
            that.props.onAbort(true, true);
            resolvePlan(1);
          });
        } else {
          _this.props.createPlan(values).then(function () {
            var planId = _this.props.createdPlan;

            if (_this.props.createdPlan.hasOwnProperty('id')) {
              planId = _this.props.createdPlan.id;
            } // Iam not exactly sure why we have this check but this does not save assessmentblocks when we are adding a plan from group page
            // if (!this.props.cloneView) {


            if (blocks != null) {
              blocks.forEach(function (block) {
                block.id = 0;
                return block;
              });
            }

            if (values.assessmentBlocks != null) {
              values.assessmentBlocks.forEach(function (block) {
                block.resources.map(function (resource) {
                  resource.originId = resource.id;
                  resource.id = 0;
                  return resource;
                });
                promises.push(new Promise( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve) {
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return _this.props.createAssessmentBlock(block, planId, 'PLAN');

                          case 2:
                            resolve(1);

                          case 3:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }()));
              });
            } // }


            if (blocks != null && blocks.length > 0) {
              promises.push(new Promise(function (resolve) {
                _this.props.saveBlocksOnReference(blocks, planId, 'PLAN').then(function () {
                  resolve(1);
                });
              }));
            }

            Promise.all(promises).then(function () {
              if (_this.props.cloneView) {
                _this.props.history.replace("".concat(getRootUrl(), "plan/").concat(planId));

                _this.props.onAbort();
              } else {
                _this.props.history.push("".concat(getRootUrl(), "plan/").concat(planId));
              }

              resolvePlan(1);
            });
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (dates) {
      _this.setState({
        dateStart: dates.start,
        dateEnd: dates.end
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onGroupSelect", function (groupid) {
      if (groupid != 0) {
        _this.setState({
          SectionId: groupid
        }, function () {
          _this.props.getSection(groupid).then(function () {
            _this.setState({
              students: _this.props.section.students
            });
          });
        });
      } else {
        _this.setState({
          SectionId: 0
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onStatusSelect", function (event) {
      _this.setState({
        status: event.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderStudents", function () {
      var section = _this.props.section;
      var SectionId = _this.state.SectionId;

      if (section != null && SectionId != 0 && SectionId != null) {
        var sectionStudents = _this.getSectionStudents();

        return sectionStudents.map(function (student) {
          var checked = false;
          var disabled = false;

          _this.state.students.find(function (studentPlan) {
            if (studentPlan.id == student.id) {
              checked = true;

              if (studentPlan.remove) {
                checked = false;
              }

              if (_this.props.assessments != null && _this.props.editView) {
                _this.props.assessments.find(function (assessment) {
                  if (assessment.studentId == student.id) {
                    disabled = true;
                  }
                });
              }
            }
          });

          var title = student.firstName + " " + student.lastName;

          if (disabled && _this.props.editView) {
            title += " (" + _this.props.translate("assessed") + ")";
          }

          if (student.missing) {
            title += " (" + _this.props.translate("removed-from-group") + ")";
          }

          return /*#__PURE__*/React.createElement("div", {
            style: {
              marginTop: "1em"
            },
            key: student.id
          }, /*#__PURE__*/React.createElement(Checkbox, {
            name: "studentSelect",
            value: checked,
            disabled: disabled,
            onChange: function onChange() {
              _this.onStudentSelect(student);
            },
            label: title
          }));
        });
      } else {
        return /*#__PURE__*/React.createElement("div", null, _this.props.translate("select-a-group-to-continue"));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onStudentSelect", function (student) {
      var foundStudent = false;

      _this.state.students.find(function (studentPlan) {
        if (studentPlan.id == student.id) {
          foundStudent = true;
        }
      });

      var students = _this.state.students;

      if (foundStudent) {
        if (student.missing && !student.remove) {
          student.remove = true;
        } else if (student.missing && student.remove) {
          student.remove = false;
        } else {
          students = students.filter(function (t) {
            return t.id != student.id;
          });
        }
      } else {
        students.push(student);
      }

      _this.setState({
        students: students
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref3) {
      var input = _ref3.input,
          label = _ref3.label,
          type = _ref3.type,
          placeholder = _ref3.placeholder,
          _ref3$meta = _ref3.meta,
          touched = _ref3$meta.touched,
          error = _ref3$meta.error,
          warning = _ref3$meta.warning;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({
        type: type,
        placeholder: placeholder || label,
        onKeyPress: function onKeyPress(e) {
          if (e.key == 'Enter') {
            e.preventDefault();
          }
        },
        style: touched && error ? {
          border: "1px solid red"
        } : {}
      }, input)), touched && (error && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: "1rem",
          color: "red"
        }
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: "1rem",
          color: "red"
        }
      }, warning)));
    });

    _defineProperty(_assertThisInitialized(_this), "consentedToTenantService", function (serviceId) {
      return _this.props.tenantServices != null && _this.props.tenantServices.find(function (service) {
        return service.serviceId == serviceId && moment(service.serviceEnd).isSameOrAfter(moment(), 'day') && service.consented !== null;
      }) != null;
    });

    _defineProperty(_assertThisInitialized(_this), "handleCancel", function (event) {
      event.preventDefault();

      _this.props.onAbort(true, false);
    });

    var _initialValues = props.initialValues,
        editView = props.editView;
    _this.state = {
      dateStart: null,
      dateEnd: null,
      status: null,
      SectionId: 0,
      loading: false,
      students: editView && _initialValues != null ? _initialValues.students : []
    };
    return _this;
  }

  _createClass(SinglePlanForm, [{
    key: "isIframe",
    value:
    /* Component methods and events */
    function isIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
    /* Redux form functions */

  }, {
    key: "getSectionStudents",
    value: function getSectionStudents() {
      var sectionStudents = this.props.section.students; // Only get missingStudents when not in copy mode

      if (!this.props.cloneView) {
        var missingStudents = this.state.students.filter(function (t) {
          return sectionStudents.find(function (s) {
            return s.id == t.id;
          }) == null;
        });
        missingStudents.forEach(function (student) {
          student.firstName = student.firstname;
          student.lastName = student.lastname;
          student.missing = true;
        });
        sectionStudents = sectionStudents.concat(missingStudents);
      }

      return sectionStudents;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var initialValues = this.props.initialValues;
      var SectionId = this.state.SectionId;
      var statuses = this.props.status.planningStatus.filter(function (t) {
        return t.selectable;
      });
      console.log("history SIGNLEFORM", this.props);

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      var disabledBlocks = [];

      if (!this.consentedToTenantService("HALDOR_COURSEPLANNING")) {
        disabledBlocks.push({
          name: 'Haldor.Blocks.Assignment',
          text: 'To use Microsoft Teams Assignments in Haldor Planning you need to request permission from your IT administrator.'
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "form-container form"
      }, /*#__PURE__*/React.createElement(Form, {
        onSubmit: this.submit,
        mutators: {
          setStatusDraft: function setStatusDraft(args, state, utils) {
            utils.changeValue(state, 'status', function () {
              return 'PLANNING_DRAFT';
            });
          },
          setStatusOpen: function setStatusOpen(args, state, utils) {
            utils.changeValue(state, 'status', function () {
              return 'PLANNING_OPEN';
            });
          }
        },
        initialValues: this.props.initialValues,
        initialValuesEqual: function initialValuesEqual() {
          return true;
        },
        render: function render(_ref4) {
          var _form$getFieldState;

          var submitting = _ref4.submitting,
              handleSubmit = _ref4.handleSubmit,
              form = _ref4.form,
              valid = _ref4.valid;
          var blocks = (_form$getFieldState = form.getFieldState('assessmentBlocks')) === null || _form$getFieldState === void 0 ? void 0 : _form$getFieldState.value;
          var subjects = [];
          var courseAdded = false;

          if (_this2.props.section != null && (blocks === null || blocks === void 0 ? void 0 : blocks.length) > 0) {
            blocks === null || blocks === void 0 ? void 0 : blocks.forEach(function (content) {
              var _content$resources;

              content === null || content === void 0 ? void 0 : (_content$resources = content.resources) === null || _content$resources === void 0 ? void 0 : _content$resources.forEach(function (resources) {
                var _resources$value, _resources$value$deta;

                resources === null || resources === void 0 ? void 0 : (_resources$value = resources.value) === null || _resources$value === void 0 ? void 0 : (_resources$value$deta = _resources$value.details) === null || _resources$value$deta === void 0 ? void 0 : _resources$value$deta.forEach(function (details) {
                  var course = _this2.props.section.courses.find(function (course) {
                    return course.details.find(function (detail) {
                      return detail.id == details.id;
                    });
                  });

                  if (course != null) {
                    courseAdded = true;

                    if (subjects.indexOf(course.subjectId) == -1) {
                      subjects.push(parseInt(course.subjectId));
                    }
                  }
                });
              });
            });
          }

          return /*#__PURE__*/React.createElement("form", {
            onSubmit: handleSubmit,
            className: "form form-component"
          }, submitting ? /*#__PURE__*/React.createElement("div", {
            className: "is_sending"
          }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
            className: "loading-spinner"
          }))) : null, _this2.props.editView && initialValues.status != "PLANNING_DRAFT" ? /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement(Select, {
            name: "type",
            label: _this2.props.translate("Status"),
            dataType: "plan",
            options: statuses,
            placeholder: false,
            onChange: _this2.onStatusSelect,
            selectedValue: initialValues.status
          })) : null, /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement(DatePickerFromTo, {
            type: "plan",
            onChange: _this2.onDateChange,
            values: initialValues,
            cloneView: _this2.props.cloneView
          })), /*#__PURE__*/React.createElement("div", {
            className: "form-row input"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate("title"), "*"), /*#__PURE__*/React.createElement(Field, {
            component: _this2.renderInput,
            type: "text",
            name: "title",
            placeholder: _this2.props.translate("title"),
            validate: _this2.required
          })), /*#__PURE__*/React.createElement("div", {
            className: "form-divider"
          }), /*#__PURE__*/React.createElement(Expandable, {
            title: _this2.props.translate('Assessments')
          }, /*#__PURE__*/React.createElement(Field, {
            component: BlockAssessments,
            name: "assessmentBlocks",
            assessmentFeedbackParts: _this2.props.cloneView ? null : _this2.props.assessments.reduce(function (prev, current, index) {
              var _this2$props$assessme, _this2$props$assessme2;

              return [].concat(_toConsumableArray(prev), _toConsumableArray((_this2$props$assessme = _this2.props.assessments[index]) === null || _this2$props$assessme === void 0 ? void 0 : (_this2$props$assessme2 = _this2$props$assessme.assessmentFeedbacks) === null || _this2$props$assessme2 === void 0 ? void 0 : _this2$props$assessme2.map(function (feedback) {
                return feedback.assessmentBlockPartId;
              })));
            }, []),
            disableRows: _this2.props.cloneView ? null : _this2.props.assessments.reduce(function (prev, current, index) {
              var _this2$props$assessme3, _this2$props$assessme4;

              return [].concat(_toConsumableArray(prev), _toConsumableArray((_this2$props$assessme3 = _this2.props.assessments[index]) === null || _this2$props$assessme3 === void 0 ? void 0 : (_this2$props$assessme4 = _this2$props$assessme3.assessmentDetails) === null || _this2$props$assessme4 === void 0 ? void 0 : _this2$props$assessme4.map(function (detail) {
                return detail.assessmentBlockPartRowId;
              })));
            }, [])
          })), /*#__PURE__*/React.createElement(Expandable, {
            title: _this2.props.translate('Aim')
          }, /*#__PURE__*/React.createElement("div", {
            className: "form-row",
            style: {
              padding: 0,
              marginBottom: "1em"
            }
          }, courseAdded ? /*#__PURE__*/React.createElement("div", {
            className: "conditional-groups-container"
          }, /*#__PURE__*/React.createElement("div", {
            className: "conditional-groups-container"
          }, /*#__PURE__*/React.createElement(Field, {
            name: "viewablePurpose",
            component: Checkbox,
            label: _this2.props.translate("Show aim to student"),
            value: true
          }))) : null), /*#__PURE__*/React.createElement(Field, {
            component: BlockPurpose,
            name: "purpose",
            assessmentBlocks: blocks
          })), /*#__PURE__*/React.createElement(Expandable, {
            title: _this2.props.translate("Subject content")
          }, /*#__PURE__*/React.createElement("div", {
            className: "form-row",
            style: {
              padding: 0,
              marginBottom: "1em"
            }
          }, courseAdded ? /*#__PURE__*/React.createElement("div", {
            className: "conditional-groups-container"
          }, /*#__PURE__*/React.createElement(Field, {
            name: "viewableCoreContent",
            component: Checkbox,
            label: _this2.props.translate("Show subject content to students"),
            value: true
          })) : null, /*#__PURE__*/React.createElement("div", {
            style: {
              clear: "both"
            }
          })), /*#__PURE__*/React.createElement(Field, {
            component: BlockCoreContentField,
            name: "associatedCoreContent",
            referenceId: initialValues === null || initialValues === void 0 ? void 0 : initialValues.id
          })), _this2.props.services.additionalAdjustments ? /*#__PURE__*/React.createElement(Expandable, {
            title: _this2.props.translate("additional-adjustments")
          }, /*#__PURE__*/React.createElement(TeacherAdjustments, {
            disableCommenting: true,
            groupId: SectionId != 0 ? SectionId : null,
            subjects: subjects
          })) : null, _this2.props.section != null ? /*#__PURE__*/React.createElement(Field, {
            component: BlockEditor,
            name: "blocks",
            disabled: disabledBlocks
          }) : null, /*#__PURE__*/React.createElement("div", {
            className: "form-divider"
          }), /*#__PURE__*/React.createElement("div", {
            className: "form-row spacing submit"
          }, /*#__PURE__*/React.createElement(Button, {
            onClick: function onClick(e) {
              e.preventDefault();
              form.mutators.setStatusOpen();
              form.submit();
            },
            disabled: submitting || !valid || SectionId == null || SectionId == "0"
          }, _this2.props.editView ? _this2.props.translate("save") : _this2.props.translate("publish")), _this2.props.editView && initialValues.status != "PLANNING_DRAFT" ? null : /*#__PURE__*/React.createElement(Button, {
            onClick: function onClick(e) {
              e.preventDefault();
              form.mutators.setStatusDraft();
              form.submit();
            },
            type: "secondary",
            disabled: submitting || !valid || SectionId == null || SectionId == "0"
          }, _this2.props.translate("save-draft")), /*#__PURE__*/React.createElement("div", {
            className: "align-right"
          }, /*#__PURE__*/React.createElement(Button, {
            type: "secondary",
            onClick: _this2.handleCancel
          }, _this2.props.translate("Cancel")))));
        }
      }));
    }
  }]);

  return SinglePlanForm;
}(Component);

function mapStateToProps(state, ownProps) {
  var initialValues = null;

  if (state.planning.active_plan != null) {
    initialValues = state.planning.active_plan;
  }

  if (state.Blocks.reference != null) {
    initialValues.blocks = JSON.parse(JSON.stringify(state.Blocks.reference));
    initialValues.assessmentBlocks = initialValues.blocks.filter(function (block) {
      return block.type == "Haldor.Blocks.AssessmentBlock";
    });

    if (ownProps.cloneView == true) {
      initialValues.blocks = initialValues.blocks.filter(function (block) {
        return block.type != 'Haldor.Blocks.Assignment';
      });
    }
  }

  return {
    initialValues: initialValues,
    translate: translate(state.Languages.translations),
    tenantServices: state.Services.tenantServices,
    section: state.sections.activeSection,
    status: state.status.status,
    groups: state.sections.educationGroups,
    assessments: state.assessments.assessments,
    services: state.Services.availableServices,
    createdPlan: state.planning.createdPlanId,
    isAppConsented: state.Services.isAppConsented
  };
}

export default withRouter(connect(mapStateToProps, {
  getSection: getSection,
  addError: addError,
  getPlanDetails: getPlanDetails,
  updatePlan: updatePlan,
  createPlan: createPlan,
  saveBlocksOnReference: saveBlocksOnReference,
  updateBlocksOnReference: updateBlocksOnReference,
  deleteBlock: deleteBlock,
  createAssessmentBlock: createAssessmentBlock,
  updateAssessmentBlock: updateAssessmentBlock,
  toggleSelectedSection: toggleSelectedSection,
  clearSelectedSections: clearSelectedSections
})(SinglePlanForm));